var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXrp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    width: "2500px",
    height: "2500px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2500 2500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n   \n    .fil1 {fill:black;fill-rule:nonzero}\n    .fil0 {fill:white;fill-rule:nonzero}\n   \n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2575040755856"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "fil0",
    cx: 1250,
    cy: 1250,
    r: 1250
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M1820 550l233 0 -486 503c-176,182 -461,182 -636,0l-486 -503 233 0 369 382c112,115 292,115 403,0l369 -382 0 0zm-1144 1400l-233 0 489 -507c176,-182 461,-182 637,0l489 507 -233 0 -372 -386c-112,-115 -292,-115 -403,0l-372 386z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrp);
export default __webpack_public_path__ + "static/media/xrp.55cd31df2631f2378a3a4db6d3b4aeb7.svg";
export { ForwardRef as ReactComponent };